export const PageInstructions = {
    title: 'Thanks! Your request is almost complete',
    subtitle:
        'It\'s important you <span class="bold">edit</span> and <span class="bold">add info </span>' +
        'to your message below (the more detail the better e.g. specific needs and the best time to contact you). ' +
        "Then click 'Send' and we will send your enquiry to the best financial adviser for your situation.",
};
